function xmlStringGen(data) {
  let res = '';
  Object.keys(data).forEach((key) => {
    if (Array.isArray(data[key])) {
      if (data[key].length) {
        let arrStr = '';
        data[key].forEach((item, i) => {
          arrStr += `&${key}[${i}]=${item}`;
        });

        res += arrStr;
      } else {
        res += `&${key}=0`;
      }
    } else {
      res += `&${key}=${data[key]}`;
    }
  });

  res = res.substr(1);

  return res;
}

export default {
  getData(url) {
    return new Promise((resolve, reject) => {
      fetch(url).then((data) => {
        data.json().then((d) => {
          resolve(d);
        });
      }).catch((e) => {
        reject(e);
      });
    });
  },
  postData(url, data, headers) {
    const h = headers ? { headers } : {};

    return new Promise((resolve, reject) => {
      fetch(url, {
        method : 'POST',
        ...h,
        body   : JSON.stringify(data)
      }).then((res) => {
        res.json().then((r) => {
          resolve(r);
        });
      }).catch((e) => {
        reject(e);
      });
    });
  },
  xmlPostData(url, data) {
    return new Promise((resolve) => {
      const xhr = new XMLHttpRequest();

      const params = xmlStringGen(data);

      console.log(params);

      xhr.open('POST', url);

      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

      xhr.onload = () => {
        resolve(xhr.readyState);
      };

      xhr.send(params.split('+').join(encodeURIComponent('+')));
    });
  },
  xmlPostDataShowFullResp(url, data) {
    return new Promise((resolve) => {
      const xhr = new XMLHttpRequest();

      const params = xmlStringGen(data);

      console.log(params);

      xhr.open('POST', url);

      xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

      xhr.onload = () => {
        resolve(xhr);
      };

      xhr.send(params.split('+').join(encodeURIComponent('+')));
    });
  }
};
